import {PaginationItemSelect} from "@/theme/ui";

export const SubCategoriesSelect = ({level, ...rest}) => {
    const transform = (categories) =>({
        id: categories.id,
        value: categories.id,
        icon: categories.icon,
        is_active: categories.is_active,
        image: categories.image,
        title: categories.title,
        label: categories.title,
        categories: categories.categories,
        translations: categories.translations,
    })

    return(
        <PaginationItemSelect
            placeholder={'Select categories'}
            requestSearchName={'title'}
            routeName={'categories.subcategories'}
            requestDataName={'data'}
            requestFilter={{
                level: level,
            }}
            transform={transform}
            {...rest}
        />
    )
}